import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { placeholder: String, selectAll: String }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["remove_button"],
      create: false,
      closeAfterSelect: false,
      hideSelected: true,
      placeholder: this.placeholderValue || "Selecione uma ou mais opções"
    })

    if (this.hasSelectAllValue) {
      this.select.on("item_add", (value) => {
        if (value !== this.selectAllValue) return

        this.select.setValue(
          Object.keys(this.select.options).filter((option) => option !== this.selectAllValue)
        )
      })
    }
  }

  disconnect() {
    this.select?.destroy()
    this.select = null
  }
}
